import { useTranslation } from 'react-i18next';
import { CheckIcon, PlusIcon } from '@heroicons/react/24/outline';

import { toggleArticleToAddToMasterdata, useWebEDIStore } from 'stores/webedi/webedi';
import { Button } from 'components/Form/Button';

type Props = {
  annotationId: string;
};

export const AddToMasterdataButton = ({ annotationId }: Props) => {
  const { t } = useTranslation();
  const isToAdd = useWebEDIStore((state) => state.articlesToAddToMasterdata.has(annotationId));

  const label = isToAdd
    ? t('webedi:fieldAnnotation.unmatchedArticleWarning.removeFromMasterdata')
    : t('webedi:fieldAnnotation.unmatchedArticleWarning.addToMasterdata');

  return (
    <Button
      type="button"
      variant={isToAdd ? 'secondary' : 'primary'}
      size="small"
      fullWidth
      LeftIcon={isToAdd ? CheckIcon : PlusIcon}
      onMouseDown={(event) => event.preventDefault()}
      onClick={() => toggleArticleToAddToMasterdata(annotationId)}
      analyticsId="webedi:unmatched_article_add_to_masterdata"
      className="min-w-0!"
    >
      {label}
    </Button>
  );
};
